import { render, staticRenderFns } from "./ActVantagens.vue?vue&type=template&id=273f6b59&scoped=true&"
import script from "./ActVantagens.vue?vue&type=script&lang=js&"
export * from "./ActVantagens.vue?vue&type=script&lang=js&"
import style0 from "./ActVantagens.vue?vue&type=style&index=0&id=273f6b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f6b59",
  null
  
)

export default component.exports